export default (cultures: object, translations: any) => {
    const result: any[] = [];

    for (const key in cultures) {
        result.push({
            lang: key.toLowerCase(),
            label: translations[`LANGUAGES.LANGUAGE_${key.toUpperCase()}`] || key.toUpperCase(),
            link: cultures[key],
        });
    }

    return result;
};
